var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 456,
    viewBox: "0 0 320 456",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-33.847 431.439C-134.039 355.823 -75.5197 189.292 20.904 138.29C57.0352 119.22 99.1513 111.903 139.716 117.224C176.29 122.103 221.953 134.521 259.414 120.329C287.787 109.463 300.865 82.6321 315.717 58.24C356.946 -9.61432 460.907 -22.2539 512.554 42.0525C531.617 65.7794 539.375 98.8195 530.066 127.868C508.121 195.279 434.529 166.452 392.856 202.597C376.231 217.01 371.798 245.837 362.044 265.129C352.07 284.865 339.878 303.713 326.8 321.674C299.314 359.593 265.842 394.185 227.273 421.017C150.356 474.679 54.1536 490.645 -27.197 436.317C-29.4137 434.765 -31.6304 433.213 -33.847 431.439Z",
    fill: "url(#paint0_radial_105_553)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_105_553",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(364.949 37.4663) rotate(-122.473) scale(729.916 1226.84)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveM);
export default __webpack_public_path__ + "static/media/wave_m.3ee0b19321a962b94290a231df87559f.svg";
export { ForwardRef as ReactComponent };